import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import '~/assets/css/swiper.css';
import { useBreakpoints } from '@vueuse/core';
import { CdnImg } from '@webplatform/cdn-image';
import { type ImageWithAltType } from '~/helpers/prepareImagesWithAlts';
import UiImagesGallery from './ui/UiImagesGallery.vue';

interface Props {
  images: ImageWithAltType[];
}
type SwiperType = InstanceType<typeof Swiper>;

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductImagesSlider',
  props: {
    images: null
  },
  setup(__props: any) {



const isSliderImagesInit = ref(false);
const breakpoints = useBreakpoints({
  sm: 640,
  md: 992,
  lg: 1280,
  xl: 1656,
});
const lgAndLarger = breakpoints.greater('lg');
const swiperOptionTop = {
  loop: true,
  slidesPerView: 1,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  breakpoints: {
    1280: {
      loopedSlides: 5,
    },
  },
  on: {
    /* eslint-disable */
    init: function () {
      isSliderImagesInit.value = true;
    },
    /* eslint-enable */
  },
};

const swiperRef = ref<SwiperType | null>(null);
const gallery = ref<InstanceType<typeof UiImagesGallery> | null>(null);

const activeThumbIndex = ref(0);

const getDynamicThumbClass = (thumbIndex: number, activeIndex: number) => {
  return {
    'cn-product-images-slider__thumb--active': thumbIndex === activeIndex,
  };
};

const onThumbImageClick = (
  thumbImageIndex: number,
  swiper: SwiperType | null,
) => {
  lgAndLarger.value && swiper && swiper.$swiper.slideToLoop(thumbImageIndex);
};

const onSlideChange = (swiper: SwiperType | null) => {
  swiper && (activeThumbIndex.value = swiper.$swiper.realIndex);
};

return { __sfc: true,isSliderImagesInit, breakpoints, lgAndLarger, swiperOptionTop, swiperRef, gallery, activeThumbIndex, getDynamicThumbClass, onThumbImageClick, onSlideChange, Swiper, SwiperSlide, CdnImg, UiImagesGallery }
}

})